import React from 'react';
import styles from './StatCard.module.css';

const StatCard = ({ label, value, delta, icon }) => {
    const isPositive = delta?.direction === 'up';
    const isNegative = delta?.direction === 'down';

    return (
        <article className={styles.card}>
            <header className={styles.header}>
                <span className={styles.label}>{label}</span>
                {icon && <span className={styles.icon}>{icon}</span>}
            </header>
            <div className={styles.valueRow}>
                <span className={styles.value}>{value}</span>
                {delta && (
                    <span
                        className={`${styles.delta} ${
                            isPositive ? styles.deltaUp : isNegative ? styles.deltaDown : ''
                        }`}
                    >
                        {isPositive && '▲ '}
                        {isNegative && '▼ '}
                        {delta.text}
                    </span>
                )}
            </div>
        </article>
    );
};

export default StatCard;

